import { Component, Input, OnInit } from '@angular/core';
import { CustomerFilterModel, CustomerStatus, CustomerStatusModel, CustomerStatusServiceProxy, UserServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { AuthService } from '../../../services/auth/auth.service';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-filter-customer',
    templateUrl: './filter-customer.component.html',
    styleUrl: './filter-customer.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class FilterCustomerComponent implements OnInit {

  selectedStatus: string | null = null;
  selectedUsers: string | null = null; 

  optionsUsers: any[] = [];
  optionsStatus: CustomerStatusModel[] = [];

  @Input() customerFilter: CustomerFilterModel = new CustomerFilterModel();

  constructor(private _userService: UserServiceProxy, private _customerStatusService: CustomerStatusServiceProxy, private authService: AuthService, private destroyService: DestroyService) {
  }

  ngOnInit(): void {
    this.getCustomerStatuses();
    this.getUser();
  }

  getCustomerStatuses() {
    this._customerStatusService.getAll(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((statuses) => {
        this.optionsStatus = statuses;
    }, error => {
      console.error(error);
    })
  }
  getUser() {
    this._userService.getUsers(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
         this.optionsUsers = res.map(r => ({ id: r.id, name: r.firstname + ' ' + r.lastname })); 
    })
  }

  
  onSelectChange(selected: string | null = null, filterArray: string = '') {
    if (!selected) {
      this.customerFilter[filterArray] = [];
      return;
    }
    if (!this.customerFilter[filterArray]) {
      this.customerFilter[filterArray] = [];
    }
    
    this.customerFilter[filterArray].push(selected);
  }

}
